import React from 'react'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import {Tooltip} from 'react-tippy'

const styles = theme => ({
	tooltip: {
		marginLeft: '6px'
	},
	icon: {
		fontSize: '20px',
		lineHeight: '20px',
		verticalAlign: 'text-top',
		color: '#4088c5'
	}
});

const HelpCircle = ({classes, children, className, iconClassName, position, offset, style}) => (
	<Tooltip
		html={children}
		arrow={true}
		interactive={true}
		delay={400}
		hideDelay={1200}
		theme="prepler"
		position={position || 'top'}
		offset={offset || 0}
		className={className || classes.tooltip}
		style={style}
	>
		<i className={classNames(classes.icon, iconClassName || 'ion-ios-help-outline')}/>
	</Tooltip>
);

export default injectSheet(styles)(HelpCircle)
